/**
 * @param {Element} parentContainer - the element from where you want to start searching for the targetClassNames
 * @param {String} targetClassNames - String of classname to search for
 * @param {String} key - the key pressed by the user (e.key)
 */

import getArrayBasedOnClassnames from './getArrayBasedOnClassnames'

export default class TabNavigation {
    constructor({ parentContainer, targetClassName, key = null }) {
        this.list = getArrayBasedOnClassnames(parentContainer, targetClassName)
        this.currentIndex = this.list.findIndex((item) => item === document.activeElement)
        this.currentIndexLast = this.currentIndex === this.list.length - 1
        this.currentIndexFirst = this.currentIndex === 0 
        this.key = key
    }

    tabTrapPrev() {
        if (!this.currentIndexFirst) {
            this.tabPrev()
        } else {
            this.tabLast()
        }
    }

    tabTrapNext() {
        if (!this.currentIndexLast) {
            this.tabNext()
        } else {
            this.tabFirst()
        }
    }

    tabPrev() {
        if (!this.currentIndexFirst) {
            this.list[this.currentIndex - 1].focus()
        }
    }

    tabNext() {
        if (!this.currentIndexLast) {
            this.list[this.currentIndex + 1].focus()
        }
    }

    tabLast() {
        this.list[this.list.length - 1].focus()
    }

    tabFirst() {
        this.list[0].focus()
    }
}